var map = {
	"./apple-laurel-da-DK.svg": 64109,
	"./apple-laurel-de-DE.svg": 2871,
	"./apple-laurel-en-GB.svg": 67541,
	"./apple-laurel-en-US.svg": 3498,
	"./apple-laurel-es-ES.svg": 12409,
	"./apple-laurel-es-MX.svg": 50810,
	"./apple-laurel-fr-FR.svg": 73533,
	"./apple-laurel-it-IT.svg": 15911,
	"./apple-laurel-nb-NO.svg": 53920,
	"./apple-laurel-nl-NL.svg": 17525,
	"./apple-laurel-pl-PL.svg": 28921,
	"./apple-laurel-pt-BR.svg": 56153,
	"./apple-laurel-pt-PT.svg": 75913,
	"./apple-laurel-sv-SE.svg": 2940
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 87083;